module.exports = __webpack_public_path__ + "img/huihui.ee706c67.jpg";